exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mql-form-title .title[data-v-057de9fc] {\n  border-left: 5px solid #ddd;\n  padding-left: 10px;\n  color: #333;\n  margin-bottom: 20px;\n  margin-left: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-057de9fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"C://Users//Administrator//Desktop//project//admin//mql_admin_pc//src//assets//style//var-fun.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/core/MqlLayout/MqlFormTitle/index.vue
// module id = asnD
// module chunks = 78